export default "a-default";
export const aNamed = "a-named";
